export const GET_SOCIAL_CATEGORY_REQUEST = "GET_SOCIAL_CATEGORY_REQUEST"
export const GET_SOCIAL_CATEGORY_SUCCESS = "GET_SOCIAL_CATEGORY_SUCCESS"
export const GET_SOCIAL_CATEGORY_FAIL = "GET_SOCIAL_CATEGORY_FAIL"
